export default __webpack_public_path__ + "static/media/vox-img-legacy-015.9a223914.jpg";